import { ScoredCreditCardProduct } from '@appTypes/EligibilityApi.interface'

function getShowGuaranteedExample(
    creditCard: ScoredCreditCardProduct
): boolean {
    return creditCard.guaranteedRate?.guaranteedAPR != null
}

export default getShowGuaranteedExample
